import InputBasico from './InputBasico'
import Vue from 'vue'
import { Validations } from '@/utils/Validations'

Vue.config.ignoredElements = ['custom-element']

/**
 * InputCelular
 */
export const InputCelular = InputBasico.extend({
	name: 'InputCelular',
	extends: InputBasico,
	props: {
		label: { default: 'Celular', type: String },
		placeholder: { default: '(00) 00000-0000' },
		mask: { default: '(00) 00000-0000' }
	},
	data: () => ({
		isValid: true,
		isLoading: false,
		lazyValue: ''
	}),
	mounted() {
		const rules = [...this.rules, Validations.isCellPhoneDigitValid, Validations.isPhoneDddValid, Validations.isCellPhoneValid]
		this.setRules(rules, this.$props)
		//If mounted with a value
		if (this.value) this.handleInput(this.value)
	}
})

export default InputCelular
